import { render, staticRenderFns } from "./recuitConfig.vue?vue&type=template&id=18a2ad1f&scoped=true&"
import script from "./recuitConfig.ts?vue&type=script&lang=ts&"
export * from "./recuitConfig.ts?vue&type=script&lang=ts&"
import style0 from "./recuitConfig.vue?vue&type=style&index=0&id=18a2ad1f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2ad1f",
  null
  
)

export default component.exports